module.exports = __webpack_public_path__ + "img/app_android_d_error.4db7a120.png";